import { render, staticRenderFns } from "./QueueTotals.vue?vue&type=template&id=44528109&scoped=true"
import script from "./QueueTotals.vue?vue&type=script&lang=js"
export * from "./QueueTotals.vue?vue&type=script&lang=js"
import style0 from "./QueueTotals.vue?vue&type=style&index=0&id=44528109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44528109",
  null
  
)

export default component.exports